import { render, staticRenderFns } from "./procurement_project_subscriptions.vue?vue&type=template&id=1b8af55c&scoped=true&"
import script from "./procurement_project_subscriptions.vue?vue&type=script&lang=js&"
export * from "./procurement_project_subscriptions.vue?vue&type=script&lang=js&"
import style0 from "./procurement_project_subscriptions.vue?vue&type=style&index=0&id=1b8af55c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8af55c",
  null
  
)

export default component.exports